module.exports = {
    extends: [
        '/',
        'templates',
        'registration',
        'form',
    ],
}